var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.0026 4.33203C37.9691 4.33203 47.6693 14.0322 47.6693 25.9987C47.6693 37.9652 37.9691 47.6654 26.0026 47.6654C14.0361 47.6654 4.33594 37.9652 4.33594 25.9987C4.33594 14.0322 14.0361 4.33203 26.0026 4.33203ZM26.0026 12.9987C25.428 12.9987 24.8769 13.227 24.4705 13.6333C24.0642 14.0396 23.8359 14.5907 23.8359 15.1654V32.4987C23.8359 33.0733 24.0642 33.6244 24.4705 34.0308C24.8769 34.4371 25.428 34.6654 26.0026 34.6654C26.5772 34.6654 27.1283 34.4371 27.5347 34.0308C27.941 33.6244 28.1693 33.0733 28.1693 32.4987V15.1654C28.1693 14.5907 27.941 14.0396 27.5347 13.6333C27.1283 13.227 26.5772 12.9987 26.0026 12.9987ZM26.0026 41.1654C26.5772 41.1654 27.1283 40.9371 27.5347 40.5308C27.941 40.1244 28.1693 39.5733 28.1693 38.9987C28.1693 38.4241 27.941 37.873 27.5347 37.4666C27.1283 37.0603 26.5772 36.832 26.0026 36.832C25.428 36.832 24.8769 37.0603 24.4705 37.4666C24.0642 37.873 23.8359 38.4241 23.8359 38.9987C23.8359 39.5733 24.0642 40.1244 24.4705 40.5308C24.8769 40.9371 25.428 41.1654 26.0026 41.1654Z",
    fill: "#F63D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningMark);
export default __webpack_public_path__ + "static/media/warning-mark.e62d50064659b47ce9a4eeedf2391b17.svg";
export { ForwardRef as ReactComponent };